import React from 'react'
import { t } from '../../../i18n'
import { CommandButton, ControlGroupKey } from '../types'
import ActionButton from './ActionButton'

const scope = 'controls'

interface Props {
  groupKey: ControlGroupKey
  commands: CommandButton[]
  cardClassName?: string
}

const SewageLayout = ({ groupKey, commands, cardClassName }: Props) => (
  <div className={cardClassName ?? 'card mb-3'}>
    <div className="card-body">
      <h6 className="card-title mb-3">{t(`groups.${groupKey}`, { scope })}</h6>
      {commands.length === 0 ? (
        <div className="text-muted fst-italic">—</div>
      ) : (
        <div className="controls-actions-grid-one">
          {commands.map(c => <ActionButton key={c.name} command={c} />)}
        </div>
      )}
    </div>
  </div>
)

export default SewageLayout
